import { countLikes, likeEntity } from '@/services/global/like.service';
import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Button from '../Button';
import { Enum_Like_Type } from '@edwin-group/people-graphql';

interface IconProps {
  entityId: string;
  moduleId?: string;
  lessonId?: string;
  type: Enum_Like_Type;
  isButtonLayout?: boolean;
  label?: string;
}

const CustomIcon: React.FC<IconProps> = ({ type, entityId, lessonId, moduleId, isButtonLayout, label }) => {
  const likeData = { id: entityId, type, lessonId, moduleId };
  const { data } = useQuery({
    queryKey: ['likeCount', likeData],
    queryFn: () => countLikes(likeData),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const queryClient = useQueryClient();

  const { likes, likedByUser } = data?.data || { likes: 0, likedByUser: false };

  let fill = 'none';

  if (likedByUser) {
    fill = '#000';
  }

  if (isButtonLayout) {
    return (
      <Button
        className="mt-4"
        onClick={async () => {
          await likeEntity({
            id: entityId,
            lessonId,
            moduleId,
            type,
          });

          queryClient.invalidateQueries({ queryKey: ['likeCount'] });
        }}>
        <svg width="18" height="18" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.26945 2.26947L5.26935 2.26937C4.76302 1.7632 4.07639 1.47885 3.36045 1.47885C2.64456 1.47885 1.95797 1.76316 1.45166 2.26926C1.45162 2.2693 1.45158 2.26934 1.45155 2.26937M5.26945 2.26947L1.45155 2.26937M5.26945 2.26947L6.20705 3.20627L6.56045 3.55937L6.91385 3.20627L7.85145 2.26947L7.85151 2.26953L7.85769 2.26312C8.10676 2.00524 8.40469 1.79955 8.7341 1.65805C9.06351 1.51654 9.41781 1.44206 9.77631 1.43894C10.1348 1.43583 10.4903 1.50414 10.8222 1.6399C11.154 1.77566 11.4555 1.97614 11.709 2.22965C11.9625 2.48316 12.163 2.78462 12.2987 3.11645C12.4345 3.44826 12.5028 3.8038 12.4997 4.1623C12.4966 4.52081 12.4221 4.8751 12.2806 5.20451C12.1391 5.53392 11.9334 5.83185 11.6755 6.08092L11.6754 6.08087L11.6693 6.08704L6.56045 11.1966L1.45166 6.08707C1.45165 6.08706 1.45164 6.08705 1.45163 6.08704C0.945474 5.58072 0.661133 4.8941 0.661133 4.17817C0.661133 3.46227 0.945444 2.77569 1.45155 2.26937M5.26945 2.26947L1.45155 2.26937"
            fill={fill}
            stroke="black"
          />
        </svg>
        {(likes || 0) > 0 ? <span className="text-sh-14-18 font-medium">{likes}</span> : null}
        {label}
      </Button>
    );
  }

  return (
    <button
      aria-label="Like"
      className="flex cursor-pointer items-center justify-center gap-2 border-none bg-none p-0"
      onClick={async () => {
        await likeEntity({
          id: entityId,
          lessonId,
          moduleId,
          type,
        });

        queryClient.invalidateQueries({ queryKey: ['likeCount'] });
      }}>
      <svg width="18" height="18" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.26945 2.26947L5.26935 2.26937C4.76302 1.7632 4.07639 1.47885 3.36045 1.47885C2.64456 1.47885 1.95797 1.76316 1.45166 2.26926C1.45162 2.2693 1.45158 2.26934 1.45155 2.26937M5.26945 2.26947L1.45155 2.26937M5.26945 2.26947L6.20705 3.20627L6.56045 3.55937L6.91385 3.20627L7.85145 2.26947L7.85151 2.26953L7.85769 2.26312C8.10676 2.00524 8.40469 1.79955 8.7341 1.65805C9.06351 1.51654 9.41781 1.44206 9.77631 1.43894C10.1348 1.43583 10.4903 1.50414 10.8222 1.6399C11.154 1.77566 11.4555 1.97614 11.709 2.22965C11.9625 2.48316 12.163 2.78462 12.2987 3.11645C12.4345 3.44826 12.5028 3.8038 12.4997 4.1623C12.4966 4.52081 12.4221 4.8751 12.2806 5.20451C12.1391 5.53392 11.9334 5.83185 11.6755 6.08092L11.6754 6.08087L11.6693 6.08704L6.56045 11.1966L1.45166 6.08707C1.45165 6.08706 1.45164 6.08705 1.45163 6.08704C0.945474 5.58072 0.661133 4.8941 0.661133 4.17817C0.661133 3.46227 0.945444 2.77569 1.45155 2.26937M5.26945 2.26947L1.45155 2.26937"
          fill={fill}
          stroke="black"
        />
      </svg>
      {(likes || 0) > 0 ? <span className="text-sh-11-20 font-medium">{likes}</span> : null}
    </button>
  );
};

export default CustomIcon;
